import { AttributeTreeData } from '@/models/reports/attribute-tree-data';
import { SortDirection } from './sort-direction';
import { Field } from './report-field';

export class OrderColumn {
    public field: Field | null;
    public direction: string;

    public constructor(field: Field | null, direction: string = 'Ascending') {
        this.field = field;

        // TODO(George)- This is a hack. we need a better way of doing this.
        switch (direction.toLowerCase()) {
        case '0':
        case 'ascending':
        default:
            this.direction = SortDirection[SortDirection.Ascending];
            break;
        case '1':
        case 'descending':
            this.direction = SortDirection[SortDirection.Descending];
            break;
        }
    }
}
